export default {
	"AtInteceptModal.YouHaveNotSavedYourShippingAddressInformationPleaseSaveItAndThenLeaveSoThatTheSystemCanHelpYouArrangeTheShipmentAsSoonAsPossible": "您還未保存您的收貨地址資訊，請保存后再離開以便系統儘快幫您安排發貨",
	"AtInteceptModal.return": "返回"
}